module.exports = __webpack_public_path__ + "img/welcometop.6bde0e29.png";